<template>
  <article ref="graphic" class="number-counter">
    <BrandGraphic class="number-counter__image" />
  </article>
</template>

<script>
import SimpleBar from 'simplebar'
import { BrandGraphic } from '@/components/common'

export default {
  name: 'HomeEvents',
  components: {
    BrandGraphic
  },
  data() {
    return {
      simplebarInstance: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.$refs.graphic || this.$device.tablet) return
      this.simplebarInstance = new SimpleBar(this.$refs.graphic)
    })
  }
}
</script>
